"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _utils = require("FileManagerLib/utils/utils");

function ThumbnailVideoDuration(_ref) {
  var duration = _ref.duration;
  return _react.default.createElement("div", {
    className: "thumbnail__video-duration flex-row align-center"
  }, _react.default.createElement(_UIIcon.default, {
    name: "playerPlay",
    color: colors.OLAF,
    size: 9,
    className: "m-top-1"
  }), _react.default.createElement("span", null, (0, _utils.millisecondsToTimer)(duration)));
}

ThumbnailVideoDuration.propTypes = {
  duration: _react.PropTypes.number
};
var _default = ThumbnailVideoDuration;
exports.default = _default;
module.exports = exports.default;